// extracted by mini-css-extract-plugin
module.exports = {"new-logo":"new-logo--132cd","newLogo":"new-logo--132cd","old-logo":"old-logo--d4b0e","oldLogo":"old-logo--d4b0e"};